import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/sy_bg.png';
import _imports_1 from '@/assets/img/2.png';
import _imports_2 from '@/assets/img/jj1.png';
import _imports_3 from '@/assets/img/zl_bg.png';
const _withScopeId = n => (_pushScopeId("data-v-07cdb934"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_3 = {
  class: "company_jj"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "jieshao"
}, [/*#__PURE__*/_createElementVNode("h2", null, [/*#__PURE__*/_createTextVNode("公司"), /*#__PURE__*/_createElementVNode("b", null, "简介")]), /*#__PURE__*/_createElementVNode("p", null, " 我们是通信、数字内容与文化娱乐融合的先锋。以创新为驱动，将前沿通信技术与丰富数字内容、多元文化娱乐巧妙融合。凭借专业团队与领先技术，打造独特用户体验，赋能行业发展，携手伙伴共创辉煌。 作为通信、数字内容和文化娱乐融合的引领者，公司依托先进技术，在融合领域深耕。我们致力于用科技连接世界，以创新推动行业变革，同时积极践行社会责任，让通信更便捷，让文化娱乐更丰富，为社会创造更大价值。 怀揣着引领行业变革的愿景，汇聚行业精英，拥有顶尖技术和丰富资源。通过持续创新，为客户提供全方位解决方案，助力合作伙伴在数字化浪潮中抢占先机，共创美好未来。 "), /*#__PURE__*/_createElementVNode("img", {
  class: "pic",
  src: _imports_2,
  alt: ""
})], -1));
const _hoisted_5 = {
  class: "jieshao"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [/*#__PURE__*/_createTextVNode("公司"), /*#__PURE__*/_createElementVNode("b", null, "团队")], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "margin": "20px auto 0"
  }
}, " 由经验丰富的通信工程师、富有创意的数字内容创作者以及深谙文化娱乐产业的专业人组成。不同背景的成员汇聚一堂，碰撞出创新的火花。我们以专业的态度和多元的视角，致力于打造领先的融合科技解决方案，为客户提供卓越的体验，与合作伙伴共创融合新时代。 ", -1));
const _hoisted_8 = {
  class: "pics"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"jieshao\" data-v-07cdb934><h2 data-v-07cdb934>公司<b data-v-07cdb934>战略</b></h2><p data-v-07cdb934> 公司专注软件和信息技术服务业、电信增值产品运营、计算机信息技术咨询、产品运营、互联网资源整合、自媒体运营、APP推广服务、音乐内容推广合作、渠道联盟运营等，在各个领域都有不俗战绩；公司本着以人为本的管理模式，制定了完善的人性化激励机制，同时吸收和培养了一批优秀的管理人才。本着诚信、创新、严谨、高效的经营理念，面对广阔但竞争激烈多变的市场，公司将对核心业务进行深度挖掘，寻求多元化的业务发展模式。 </p><div class=\"flex\" data-v-07cdb934><div style=\"width:50%;\" data-v-07cdb934><img style=\"height:100%;\" src=\"" + _imports_3 + "\" alt=\"\" data-v-07cdb934></div><div class=\"company_zl\" data-v-07cdb934><div class=\"top\" data-v-07cdb934><h3 data-v-07cdb934>公司的核心要素</h3><span data-v-07cdb934>量化目标（如市场份额、营收增长率）与非量化目标（如品牌影响力）</span></div><div class=\"info\" data-v-07cdb934><span data-v-07cdb934></span>企业愿景：成为全球领先的科技企业，引领通信与数字内容创新，丰富人类生活。 <br data-v-07cdb934><span data-v-07cdb934></span>企业使命：通过技术创新，提供卓越的通信与数字内容服务，推动社会进步与发展。 <br data-v-07cdb934><span data-v-07cdb934></span>公司目标：短期目标为提升市场份额与品牌知名度；长期目标则是成为行业领导者，实现技术与社会价值的双重突破。 <br data-v-07cdb934><span data-v-07cdb934></span>公司价值观：诚信为本，创新为魂，客户至上，团队合作，追求卓越。 <br data-v-07cdb934><span data-v-07cdb934></span>企业精神：勇于创新，敢于挑战，团结协作，敬业奉献。 </div><div class=\"bottom\" data-v-07cdb934>TARGET</div></div></div></div>", 1);
import { reactive, onMounted } from 'vue';
import Headers from "@/components/header/index.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      list: [{
        title: '企业愿景：',
        info: '铸精品游戏，做中国EA！'
      }, {
        title: '企业使命：',
        info: '聚焦玩家需求，持续创造快乐和惊喜'
      }, {
        title: '公司目标：',
        info: '把对制作游戏具有发自内心的共同热爱的人们聚合起来，建立世界一流的的游戏研发与运营团队，不断创造引领时代潮流的精品游戏，持续为玩家带来充满惊喜的游戏体验与乐趣。'
      }, {
        title: '公司价值观：',
        info: '一切围绕用户需求展开，一切以用户价值为依归'
      }]
    });
    onMounted(() => {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Headers, {
        class: "headers"
      }), _hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6], item => {
        return _createElementVNode("img", {
          style: {
            "width": "31%"
          },
          key: item,
          src: require(`@/assets/img/t${item}.png`),
          alt: ""
        }, null, 8, _hoisted_9);
      }), 64))])]), _hoisted_10])]);
    };
  }
});